<span [stickyPopover]="popContent"
      [popoverTitle]="popTitle"
      [autoClose]="'outside'"
      [animation]="false"
      [openDelay]="300"
      popoverClass='cell-popover'
      container="body"
      triggers="manual"
      class="badge bg-light text-dark border border-dark w-100 fw-light"
      style="font-size: 11px">
  {{text}}
</span>

<ng-template #popTitle>
  <ng-content select="title"></ng-content>
</ng-template>

<ng-template #popContent>
  <ng-content select="content"></ng-content>
</ng-template>
